<div class="h-full flex flex-col gap-2 z-0 relative overflow-y-auto  p-2 lg:pl-0">
    <div
        class="max-w-6xl p-4 rounded-lg bg-white dark:bg-zinc-950"
        [ngClass]="{
            'shadow-lg border border-zinc-950/10 dark:border-white/10': source !== 'modal'
        }">
        <form [formGroup]="customerForm" (ngSubmit)="onSave()">
            <h1 *ngIf="source !== 'modal'" class="heading">
                {{customerId ? 'Edit' : 'Add'}}
            </h1>
            <hr *ngIf="source !== 'modal'" class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <section class="grid gap-4 sm:grid-cols-2">
                <!-- DisplayName -->
                <div class="space-y-1">
                    <label class="subheading after:text-red-600 after:content-['*']">
                        Display Name
                    </label>
                    <div>
                        <div>
                            <input formControlName="DisplayName" type="text" />
                        </div>
                        <div *ngIf="submitted && form.DisplayName.errors">
                            <p *ngIf="form.DisplayName.errors.required" class="pt-1 text-red-600 text-xs">
                                Display Name is required
                            </p>
                            <p *ngIf="form.DisplayName.errors.unique" class="pt-1 text-red-600 text-xs">
                                A customer with this Display Name already exists in this company
                            </p>
                        </div>
                    </div>
                </div>

                <!-- email -->
                <ng-container formGroupName="PrimaryEmailAddr">
                    <div class="space-y-1">
                        <label class="subheading after:text-red-600 after:content-['*']">
                            Email
                        </label>
                        <div>
                            <div>
                                <input formControlName="Address" type="text" />
                            </div>
                            <div *ngIf="submitted && primaryEmailAddr.get('Address')?.errors">
                                <p *ngIf="primaryEmailAddr.get('Address')?.errors?.required"
                                    class="pt-1 text-red-600 text-xs">
                                    Email is required
                                </p>

                            </div>
                        </div>
                    </div>
                </ng-container>

                <!-- Contact -->
                <ng-container formGroupName="PrimaryPhone">
                    <div class="space-y-1">
                        <label class="subheading after:text-red-600 after:content-['*']">
                            Phone Number
                        </label>
                        <div>
                            <div>
                                <input formControlName="FreeFormNumber" type="text" />
                            </div>
                            <div *ngIf="submitted && primaryPhone.get('FreeFormNumber')?.errors">
                                <p *ngIf="primaryPhone.get('FreeFormNumber')?.errors?.required"
                                    class="pt-1 text-red-600 text-xs">
                                    Phone Number is required
                                </p>
                                <p *ngIf="submitted && (primaryPhone.get('FreeFormNumber')?.errors?.minlength || primaryPhone.get('FreeFormNumber')?.errors?.maxlength)" class="pt-1 text-red-600 text-xs">
                                Minimum 10 digits are required and maximum 13 digits are allowed
                            </p>

                            </div>

                        </div>
                    </div>
                </ng-container>



                <!-- address -->
                <ng-container formGroupName="BillAddr">

                    <!-- line1 -->
                    <div class="space-y-1">
                        <label class="subheading after:text-red-600 after:content-['*']">
                            Address
                        </label>
                        <div>
                            <div>
                                <input googlePlace (onSelect)="onSelectAddress($event)" (input)="onChangeAddress()" formControlName="Line1"
                                    name="Line1" id="Line1" type="text" />
                            </div>
                        </div>

                        <div *ngIf="submitted && (billAddr.get('Line1')?.errors)">
                            <p *ngIf="billAddr.get('Line1')?.errors?.required" class="pt-1 text-red-600 text-xs">
                                Address is required
                            </p>
                        </div>
                        <div>
                            <p *ngIf="submitted && billAddr.errors?.invalidAddress" class="mt-2 text-red-600 text-xs">
                                Invalid address (select from the dropdown)
                            </p>
                        </div>
                       
                    </div>

                    <!-- CountrySubDivisionCode -->
                    <div class="space-y-1">
                        <label class="subheading after:text-red-600 after:content-['*']">
                            Country Sub Division Code
                        </label>
                        <div>
                            <div>
                                <input formControlName="CountrySubDivisionCode" name="CountrySubDivisionCode"
                                    placeholder="" id="address" type="text" />
                            </div>
                        </div>

                        <div *ngIf="submitted && (billAddr.get('CountrySubDivisionCode')?.errors)">
                            <p *ngIf="billAddr.get('CountrySubDivisionCode')?.errors?.required"
                                class="pt-1 text-red-600 text-xs">
                                Country Sub Division Code is required
                            </p>
                        </div>
                    </div>

                    <!-- city -->
                    <div class="space-y-1">
                        <label class="subheading after:text-red-600 after:content-['*']">
                            City
                        </label>
                        <div>
                            <div>
                                <input formControlName="City" name="City" id="City" type="text" />
                            </div>
                            <div *ngIf="submitted && (billAddr.get('City')?.errors)">
                                <p *ngIf="billAddr.get('City')?.errors?.required" class="pt-1 text-red-600 text-xs">
                                    City is required
                                </p>
                            </div>

                        </div>
                    </div>

                    <!-- Postal code -->
                    <div class="space-y-1">
                        <label class="subheading after:text-red-600 after:content-['*']">
                            Postal Code
                        </label>
                        <div>
                            <div>
                                <input formControlName="PostalCode" name="PostalCode" id="PostalCode" type="text" />
                            </div>
                            <div *ngIf="submitted && (billAddr.get('PostalCode')?.errors)">
                                <p *ngIf="billAddr.get('PostalCode')?.errors?.required"
                                    class="pt-1 text-red-600 text-xs">
                                    Postal Code is required
                                </p>
                            </div>

                        </div>
                    </div>

                    <!-- Country -->
                    <div class="space-y-1">
                        <label class="subheading after:text-red-600 after:content-['*']">
                            Country
                        </label>
                        <div>
                            <div>
                                <input formControlName="Country" name="Country" id="Country" type="text" />
                            </div>
                        </div>

                        <div *ngIf="submitted && (billAddr.get('Country')?.errors)">
                            <p *ngIf="billAddr.get('Country')?.errors?.required" class="pt-1 text-red-600 text-xs">
                                Country is required
                            </p>
                        </div>
                    </div>

                </ng-container>

                <!-- Notes -->
                <div class="space-y-1 col-span-full">
                    <label class="subheading after:text-red-600 after:content-['*']">Notes </label>
                    <div>
                        <div>
                            <textarea formControlName="Notes" type="text" name="" rows="3" class=""> </textarea>
                        </div>
                        <div *ngIf="submitted && form.Notes.errors">
                            <p *ngIf="form?.Notes?.errors?.required" class="pt-1 text-red-600 text-xs">
                                Notes are required
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <h1 class="heading mt-4">
                Reference
            </h1>
            <hr class="my-2 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <section class="grid gap-4 sm:grid-cols-2" formGroupName="reference">
                <!-- ---reference -->

                <div class="space-y-1">
                    <!-- selectedFS -->
                    <div class="space-y-1">
                        <label class="subheading">Funding Source</label>
                        <div>
                            <ng-select [(ngModel)]="selectedFS" id="fundingSources"
                                (change)="onFundingSourceChange($event)" [ngModelOptions]="{standalone: true}" [clearable]="false" [searchable]="true"
                                [notFoundText]="'No record found'" placeholder="Select Funding Source">
                                <ng-option value="" disabled>Select Funding Source</ng-option>
                                <ng-option *ngFor="let item of fundingSources" [value]="item.id">
                                    {{ item.title | titlecase }}
                                </ng-option>
                            </ng-select>
                        </div>

                    </div>
                </div>

                <div class="space-y-1">
                    <label class="subheading">
                        Name
                    </label>
                    <div>
                        <div>
                            <input formControlName="name" name="name" id="name" type="text" />
                        </div>
                    </div>
                </div>

                <div class="space-y-1">
                    <label class="subheading">
                        ID
                    </label>
                    <div>
                        <div>
                            <input formControlName="id" name="id" id="id" type="text" />
                        </div>
                    </div>
                </div>

            </section>

            <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <section class="flex justify-end gap-4">
                <button type="submit" class="btn btn-secondary">
                    {{customerId ? 'Update' : 'Create'}}
                </button>
            </section>
        </form>
    </div>
</div>